import { cn } from "@/lib/utils";

// Professional empty-state used across every module page.
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  testId = "empty-state",
}) {
  return (
    <div
      data-testid={testId}
      className={cn(
        "flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-muted/30 px-6 py-16 text-center",
        className
      )}
    >
      {Icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-background text-primary shadow-soft ring-1 ring-border">
          <Icon className="h-5 w-5" />
        </div>
      )}
      <h3 className="text-lg font-semibold tracking-tight text-foreground">
        {title}
      </h3>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
